// İSG uzmanı portalı — tarayıcı çevrimiçi durumu (Güvenlik masası bağlantı göstergesi,
// tasarım spec'i §8.8). `navigator.onLine` yalnız kaba bir sinyaldir (yakalayıcı portal gibi
// durumları KAÇIRABİLİR); bu yüzden Güvenlik masası bunu son yoklama sonucuyla BİRLEŞTİRİR
// (bkz. `useGateCode.ts`'in `pollHealthy` dönüşü) — burası yalnız tarayıcı sinyalidir.

import { useEffect, useState } from 'react';

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    function handleOnline() {
      setOnline(true);
    }
    function handleOffline() {
      setOnline(false);
    }
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
